import { createAction } from '@reduxjs/toolkit';

export const clearOrder = createAction('clearOrder');
